module.exports = __webpack_public_path__ + "static/media/edit.0f17b48a.svg";